<template>
  <div class="not-found">
    <img src="@/assets/image/kaifazhong.png" alt />
    <p>建设中</p>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="less" scoped>
.not-found {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: #555;
  font-size: 48px;
  p{margin: 20px 0 0 0;font-size: 30px;color:#078fe2;}
}
</style>